import { render, staticRenderFns } from "./NotificationSettingEmailRequestDocs.vue?vue&type=template&id=ba522098&scoped=true"
import script from "./NotificationSettingEmailRequestDocs.vue?vue&type=script&lang=js"
export * from "./NotificationSettingEmailRequestDocs.vue?vue&type=script&lang=js"
import style0 from "./NotificationSettingEmailRequestDocs.vue?vue&type=style&index=0&id=ba522098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba522098",
  null
  
)

export default component.exports